import React from 'react';
import Section from './Section';

const experiences = [
  {
    role: 'Applied AI Engineering Intern',
    org: 'Lead Bank',
    location: 'Sunnyvale, CA',
    period: 'Jul–Aug 2026',
    bullets: [
      'Built AI agents to automate workflows across Legal, Engineering, and Executive teams, improving internal productivity through custom AI solutions.',
      'Integrated custom Model Context Protocol servers into AI workflows, enabling secure access to internal tools, data sources, and business systems.',
      'Developed an understanding of Banking-as-a-Service, including payments infrastructure, embedded finance, and the role of stablecoins in modern financial systems.',
    ],
  },
  {
    role: 'Teaching Assistant',
    org: 'Tufts CS40: Machine Structure & Assembly Language Programming',
    location: 'Medford, MA',
    period: 'May 2026 – Present',
    bullets: [
      'Lead a weekly CS40 lab, reinforcing computer architecture, memory management, C programming, and x86 assembly through hands-on exercises.',
      'Debug C and x86 assembly programs with students during office hours, covering pointers, memory, caching, and low-level program execution.',
      'Grade programming assignments and provide detailed technical feedback on correctness, style, memory usage, and systems-level concepts.',
    ],
  },
  {
    role: 'Head of Operations and Software Developer',
    org: 'Tufts JumboCode',
    location: 'Medford, MA',
    period: 'Sep 2024 – Present',
    bullets: [
      'Manage a $10K+ annual budget and oversee operations for Tufts’ largest student organization, with 120+ members, events for 300+ attendees, and representation before the Student Senate.',
      'Develop a full-stack resource management platform for Commonwealth Kitchen after adapting the project from an initial job board to meet evolving stakeholder needs.',
    ],
  },
  {
    role: 'Director of Tech Consulting',
    org: 'TAMID Group at Tufts',
    location: 'Medford, MA',
    period: 'Sep 2025 – Present',
    bullets: [
      'Lead and mentor teams of 4–8 technical consultants across remote software development projects for Israeli companies, ensuring effective collaboration, client communication, and on-time delivery of final solutions.',
      'Design and deliver a comprehensive tech consulting education program, training new members in technical and consulting fundamentals.',
    ],
  },
  {
    role: 'Social Justice Intern',
    org: 'Tufts University Hillel',
    location: 'Medford, MA',
    period: 'Mar 2025 – Present',
    bullets: [
      'Lead a free after-school arts and engineering program serving 50+ local middle school students, supervising 20+ student volunteers to deliver twice weekly programming.',
      'Organize and coordinate 40+ educational and community programs by managing logistics, recruiting participants, and collaborating with parents and school administrators.',
      'Collaborate with a coalition of seven social justice initiatives to expand programming and strengthen community partnerships.',
    ],
  },
];

const WorkExperience = () => {
  return (
    <Section id="experience" label="Experience">
      <ul className="space-y-12">
        {experiences.map((exp) => (
          <li key={`${exp.org}-${exp.role}`}>
            <div className="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:justify-between sm:gap-8">
              <h3 className="font-display text-xl font-semibold tracking-tight text-ink">
                {exp.role}
              </h3>
              <p className="shrink-0 text-sm tabular-nums text-muted">{exp.period}</p>
            </div>
            <p className="mt-1 text-muted">
              {exp.org}
              <span className="text-mist"> · </span>
              {exp.location}
            </p>
            <ul className="mt-4 space-y-2.5">
              {exp.bullets.map((bullet) => (
                <li key={bullet} className="max-w-prose leading-relaxed text-ink/80">
                  {bullet}
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </Section>
  );
};

export default WorkExperience;
